/* src/app/features/contratacao/calculo-ecg/calculo-ecg.component.scss */
/*# sourceMappingURL=calculo-ecg.component.css.map */
